export var CARD_CLASS_PREFIX = 'Card';